import calls from '@/backend/api-calls'

const state = () => ({
  storageTypes: [],
  loading: false
})

// getters
const getters = {
  ids: state => {
    return state.storageTypes.map(d => d.id);
  }
}

// actions
const actions = {
  getStorageTypes: ({commit}, parameters) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.storageTypes.get(parameters)
        .then(resp => {
          commit("setStorageTypes", resp.data);
          commit("setLoading", false);
          resolve(resp);
        }).catch(err => {
          commit("setLoading", false);
          reject(err);
        })
    })
  },
  addStorageType({commit}, data) {
    return new Promise((resolve, reject) => {
      calls.storageTypes.post(data)
        .then(resp => {
          commit("insertStorageType", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Storage type successfully added'
          }, { root: true });
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  updateStorageType: ({commit}, { storageTypeId, data }) => {
    return new Promise((resolve, reject) => {
      calls.storageType.put(storageTypeId, data).then(
        resp => {
          commit("insertUpdatedStorageType", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Storage type successfully updated'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  deleteStorageType: ({commit}, storageTypeId) => {
    return new Promise((resolve, reject) => {
      calls.storageType.delete(storageTypeId).then(
        resp => {
          commit("removeStorageType", storageTypeId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Storage type successfully deleted'
          }, { root: true });

          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  toggleAllSelected: ({commit, getters}, value) => {
    if (value) {
      commit("selectAll", getters.ids);
    } else {
      commit("deselectAll");
    }
  }
}

// mutations
const mutations = {
  setLoading(state, status) {
    state.loading = status;
  },
  setStorageTypes(state, data) {
    state.pagination = data.pagination;
    state.storageTypes = data.results;
  },
  insertStorageType(state, data) {
    state.storageTypes.push(data);
  },
  insertUpdatedStorageType(state, data) {
    state.storageTypes.forEach((storageType, i) => {
      if (storageType.id == data.id) {
        state.storageTypes.splice(i, 1, data);
      }
    })
  },
  removeStorageType(state, storageTypeId) {
    state.storageTypes.forEach((storageType, i) => {
      if (storageType.id == storageTypeId) {
        state.storageTypes.splice(i, 1);
      }
      const index = state.selected.indexOf(storageTypeId);
      if (index != -1) {
        state.selected.splice(index, 1);
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}